import * as StringHelpers from './StringHelpers';

export function formatName(organization) { // eslint-disable-line import/prefer-default-export
  return organization.split(' ').map(j => StringHelpers.capitalize(j)).join(' ');
}
